<form class="needs-validation mt-2" [formGroup]="form" novalidate>

    <h4>{{ title }} Corte / Producción autorizada para el cultivo</h4>

    <div class="row">
        <div class="col-md-12">
            <div class="card card-accent-success animated fadeIn">
                <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                    <div class="card-header-buscador">
                        <i class="icon-aforos_cortes"></i> Datos del Corte
                        <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                        <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                    </div>
                </a>
                <div class="card-body-detalle">
                    <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">

                        <div class="row">

                            <div class="form-group col-md-4 col-lg-4">
                                <label class="col-form-label required-field" for="IdCultivo" title="Cultivo/Variedad">Variedad cultivo</label>
                                <ng-select appendTo="body"
                                    loadingText="Cargando..."
                                    [items]="cultivos"
                                    [readonly]="!cultivos || cultivos?.length === 0"
                                    bindLabel="Variedad"
                                    bindValue="Id"
                                    formControlName="IdCultivo"
                                    [loading]="cultivos === null"
                                    placeholder="-- Seleccione un Cultivo --"
                                    [ngClass]="displayFieldCssNgSelect('IdCultivo')"
                                    (change)="onCultivoSelected($event)"
                                    notFoundText="Cultivo no encontrado"
                                    aria-describedby="validationCultivoFeedback"
                                    clearAllText="Eliminar selección">
                                    <ng-template ng-option-tmp let-item="item">
                                        <div container="body" ngbTooltip="{{ item.Variedad + '-' + item.CodigoSigPacRecinto + '-' + item.Identificador }}">{{ item.Variedad + '-' + item.CodigoSigPacRecinto + '-' + item.Identificador }}</div>
                                    </ng-template>
                                </ng-select>

                                <div id="validationCultivoFeedback" class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdCultivo','required')">
                                    Cultivo es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-2 col-lg-2">
                                <!-- READONLY SET ON FORM CONSTRUCTION -->
                                <label class="col-form-label" for="CodigoSigPacRecinto">Código Sigpac Recinto</label>
                                <input formControlName="CodigoSigPacRecinto" name="CodigoSigPacRecinto" class="form-control" id="CodigoSigPacRecinto" type="text" value="">
                            </div>
                            
                            <div class="form-group col-md-2 col-lg-2">
                                <!-- READONLY SET ON FORM CONSTRUCTION -->
                                <label class="col-form-label" for="IdentificadorCultivo">Id. Cultivo</label>
                                <input formControlName="IdentificadorCultivo" name="IdentificadorCultivo" class="form-control" id="IdentificadorCultivo" type="text" value="">
                            </div>                            

                            <div class="form-group col-md-2 col-lg-2">
                                <!-- READONLY SET ON FORM CONSTRUCTION -->
                                <label class="col-form-label" for="SuperficieVariedad">Superficie Cultivo (Ha)</label>
                                <input formControlName="SuperficieVariedad" name="SuperficieVariedad" class="form-control" id="SuperficieVariedad" type="text" value="">
                            </div>

                            <div class="form-group col-md-2 col-lg-2">
                                <!-- READONLY SET ON FORM CONSTRUCTION -->
                                <label class="col-form-label" for="ProduccionEstimada">Producción Estimada (Kg)</label>
                                <input formControlName="ProduccionEstimada" name="ProduccionEstimada" class="form-control" id="ProduccionEstimada" type="text" value="">
                            </div>
                        </div>

                        <div class="row">

                            <div class="form-group col-md-4 col-lg-4">
                                <label class="col-form-label required-field" for="IdAlmacen" title="Almacén">Almacén</label>
                                <ng-select appendTo="body"
                                    loadingText="Cargando..."
                                    [items]="almacenes"
                                    [readonly]="!almacenes || almacenes?.length === 0"
                                    bindLabel="RegistroSanitario"
                                    bindValue="Id"
                                    formControlName="IdAlmacen"
                                    [loading]="almacenes === null"
                                    placeholder="-- Seleccione un Almacén --"
                                    [ngClass]="displayFieldCssNgSelect('IdAlmacen')"
                                    notFoundText="Almacén no encontrado"
                                    aria-describedby="validationAlmacenFeedback"
                                    clearAllText="Eliminar selección">
                                    <ng-template ng-option-tmp let-item="item">
                                        <div container="body" ngbTooltip="{{ item.RegistroSanitario }} - {{ item.RazonSocial }}">{{ item.RegistroSanitario }} - {{ item.RazonSocial }}</div>
                                    </ng-template>
                                </ng-select>

                                <div id="validationAlmacenFeedback" class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdAlmacen','required')">
                                    Almacén es obligatorio
                                </div>
                                <div *ngIf="form.value.IdCultivo !== null && almacenes?.length === 0" class="nota-info warning">
                                    <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> No hay almacenes autorizados para exportación</label>
                                </div>
                            </div>

                            <div class="form-group col-md-2 col-lg-2">
                                <label class="col-form-label required-field" for="Corte">Corte / Kgs Autorizados</label>
                                <input formControlName="Corte" name="Corte" class="form-control" id="Corte" type="text" value="">
                                <div id="validationBolsaProductivaFeedback" class="invalid-feedback d-block" *ngIf="isFieldInvalid('Corte','required')">
                                    Corte es obligatorio
                                </div>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Corte','CorteInvalido', true)">
                                    El corte debe ser inferior al aforo
                                </div>
                            </div>

                            <div class="form-group col-md-2 col-lg-6">
                                <label class="col-form-label" for="Exportador">Exportador</label>
                                <input formControlName="Exportador" name="Exportador" class="form-control" id="Exportador" type="text" value="">
                            </div>

                            <div class="form-group col-md-2 col-lg-2">
                                <label class="col-form-label" for="FechaCaducidad">Fecha Caducidad</label>
                                <p-calendar appendTo="body" formControlName="FechaCaducidad" inputStyleClass="form-control" [minDate]="caducidadMinimumDate" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('FechaCaducidad','FechaCaducidadFueraDePeriodo', true)">
                                    La fecha de caducidad no puede ser superior a la fecha fin del periodo
                                </div>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('FechaCaducidad','FechaCaducidadFueraPlazo', true)">
                                    La fecha de caducidad es anterior al plazo de exportación vigente
                                </div>
                            </div>

                            <!-- READONLY SET ON FORM CONSTRUCTION -->
                            <div class="form-group col-md-2 col-lg-2" *ngIf="habilitadaExportacion">
                                <label class="col-form-label" for="FechaInicioExportacion">Fecha Inicio Exportación</label>
                                <p-calendar appendTo="body" formControlName="FechaInicioExportacion" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" [showTime]="true" hourFormat="24"></p-calendar>
                                <div class="invalid-feedback d-block" *ngIf="fechaFinPeriodo && !fechaInicioExportacion">
                                    NO hay plazo de exportación vigente
                                </div>
                            </div>
                            
                            <!-- READONLY SET ON FORM CONSTRUCTION -->
                            <div class="form-group col-md-2 col-lg-2">
                                <label class="col-form-label" for="FechaFinPeriodo">Fecha Fin Periodo</label>
                                <p-calendar appendTo="body" formControlName="FechaFinPeriodo" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" [showTime]="true" hourFormat="24"></p-calendar>                              
                            </div>                            
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="card card-accent-success animated fadeIn">
                <a class="card-header-a" (click)="isCollapsedAforo = !isCollapsedAforo" [attr.aria-expanded]="!isCollapsedAforo" aria-controls="collapseExample">
                    <div class="card-header-buscador">
                        <i class="icon-aforos_cortes"></i> Datos del Aforo
                        <i *ngIf="isCollapsedAforo" class="fa fa-caret-down float-right"></i>
                        <i *ngIf="!isCollapsedAforo" class="fa fa-caret-up float-right"></i>
                    </div>
                </a>
                <div class="card-body-detalle">
                    <div class="collapse group-filtros" id="isCollapsedAforo" [ngbCollapse]="isCollapsedAforo">

                        <div class="row">
                            <div class="form-group col-md-4 col-lg-4">
                                <div class="input-group">
                                    <label class="col-form-label required-field" for="Idradaro" title="Aforo de Cultivo">Aforo de Cultivo</label>
                                    <ng-select appendTo="body"
                                        loadingText="Cargando..."
                                        [items]="aforosCultivos"
                                        [readonly]="!aforosCultivos || aforosCultivos?.length === 0"
                                        bindLabel="Descripcion"
                                        bindValue="Id"
                                        formControlName="IdAforo"
                                        [loading]="aforosCultivos === null"
                                        placeholder="-- Seleccione un Aforo de Cultivo --"
                                        [ngClass]="displayFieldCssNgSelect('IdAforo')"
                                        (change)="onAforoCultivoSelected($event)"
                                        notFoundText="Aforos de Cultivos no encontrados"
                                        aria-describedby="validationAforoCultivoFeedback"
                                        clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>
                                </div>
    
                                <div id="validationAforoCultivoFeedback" class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdAforo','required')">
                                    Aforo de Cultivo es obligatorio
                                </div>
                                <div *ngIf="form.value.IdCultivo !== null && aforosCultivos?.length === 0" class="nota-info warning">
                                    <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> No hay aforos de cultivos disponibles</label>
                                </div>
                            </div>
    
                            <div class="form-group col-md-2 col-lg-2">
                                <label class="col-form-label required-field" for="ProduccionAforada">Producción Aforada (Kg)</label>
                                <input formControlName="ProduccionAforada" name="ProduccionAforada" class="form-control" id="ProduccionAforada" type="text" value="">
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('ProduccionAforada','required')">
                                    Producción Aforada es obligatoria
                                </div>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('ProduccionAforada','ProduccionAforadaSuperior', true)">
                                    Valor deberá ser superior o igual al anterior.
                                </div>
                            </div>
    
                            <!-- READONLY SET ON FORM CONSTRUCTION -->
                            <div class="form-group col-md-2 col-lg-2">
                                <label class="col-form-label" for="ProduccionReal">Producción Real (Kg)</label>
                                <input formControlName="ProduccionReal" name="ProduccionReal" class="form-control" id="ProduccionReal" type="text" value="">
                            </div>

                            <!-- READONLY SET ON FORM CONSTRUCTION -->
                            <div class="form-group col-md-2 col-lg-3">
                                <label class="col-form-label" for="KgsAcumuladosCorte">Acumulados por Cortes (Kg)</label>
                                <input formControlName="KgsAcumuladosCorte" name="KgsAcumuladosCorte" class="form-control" id="KgsAcumuladosCorte" type="text" value="">
                            </div>
                        </div>                 

                    </div>
                </div>
            </div>
        </div>
    </div>    

</form>